/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener("load", function() {
  console.log(document.querySelectorAll(".cm_collapsible-elem.collapsed"));
  document.querySelectorAll(".cm_collapsible-elem.collapsed").forEach(function(obj) {
    obj.parentElement.querySelector(".cm_vehicle-widget_header").dispatchEvent(new Event('click'));
  });
});

// EasyTabs Custom Start:
document.addEventListener('easytabs_page_inited', function(){
  let easySpecificationTab = document.querySelector('.easytabs-container .easytabs-tab-item[data-et-handle=tabs-spezifikation]');
  let easySpecificationContent = document.querySelector('.easytabs-container .easytabs-content-item[data-et-handle=tabs-spezifikation]');
  if(easySpecificationTab && !easySpecificationContent.querySelector('.easytabs-content-holder').hasChildNodes() ) {
    easySpecificationTab.classList.add("easyHidden");
    easySpecificationContent.classList.add("easyHidden");
  }
})

document.addEventListener("DOMContentLoaded", function() {
  var target = document.querySelector('body');
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if(mutation.type == 'childList' && document.querySelector('.product-meta .loox-rating') && document.querySelector('.easytabs-container .easytabs-tab-item[data-et-handle="tabs-bewertung"]')){
        observer.disconnect();
        let looxRating = document.querySelector(".product-meta .loox-rating .loox-rating-content");
        let looxReviewsTab = document.querySelector('.easytabs-container .easytabs-tab-item[data-et-handle="tabs-bewertung"]');
        let looxReviewsAccordionTab = document.querySelector('.easytabs-container .easytabs-content-item[data-et-handle="tabs-bewertung"]');
        if (!looxRating && looxReviewsTab && looxReviewsAccordionTab){
          looxReviewsTab.classList.add("easyHidden");
          looxReviewsAccordionTab.classList.add("easyHidden");
        }
      }
    });    
  });
  var config = { attributes: true, childList: true, characterData: true };
  observer.observe(target,  config);
});
// EasyTabs Custom Finish